import { Component } from '@angular/core';
import * as Bowser from "bowser"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Back to Work';
  styles = ` /* Safari fix */
  .container-landing-page div[fxFlex]{
    flex: 1 0 auto !important;
  }
  .container-principal div[fxFlex]:not(.no-style-safari):not(.container-contact-tracing div){
    flex: 1 1 auto !important;
  }
`;

  ngOnInit() {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getBrowserName() == 'Safari') {
      var styleSheet = document.createElement("style")
      styleSheet.type = "text/css"
      styleSheet.innerText = this.styles;
      document.head.appendChild(styleSheet)
    }

  }

}
